import type { Mirror } from "@/lib/mirror"
import { hasStringId } from "@/lib/validation/hasStringId"
import { isArray } from "@/lib/validation/isArray"

export const buildMirror = <Element>(
  data: Mirror.Format<Element> = {},
  options?: Mirror.Options<Element>
): Mirror<Element> => {
  if (isArray(data)) {
    const collection = data.reduce<Mirror.Collection<Element>>(
      (result, record) => {
        if (options?.extractKey) {
          result[options.extractKey(record)] = record
          return result
        }

        if (hasStringId(record)) {
          result[record.id] = record
          return result
        }

        throw new Error(
          `buildMirror failed because a record has no id and no extractKey function was provided. { record: ${JSON.stringify(
            record
          )} }`
        )
      },
      {}
    )

    return {
      array: Object.freeze(data),
      collection: Object.freeze(collection),
    }
  }

  if (typeof data === `object`) {
    const array = Object.values(data)

    return {
      array: Object.freeze(array),
      collection: Object.freeze(data),
    }
  }

  throw new Error(
    `buildMirror failed because data is not an array or object. { data: ${JSON.stringify(
      data
    )}}`
  )
}
